import styled from 'styled-components'

import { IconArrow } from '@avantstay/backoffice-vectors'

import { _M_Medium, _XS_Normal, semanticColors } from '../../styles'

export const PercentageChangeWrapper = styled.div<{ positive?: boolean; small?: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ positive }) =>
    positive ? semanticColors.successMedium : semanticColors.failureMedium};
  ${({ small }) => (small ? _XS_Normal : _M_Medium)};
`

export const ArrowUp = styled(IconArrow)``

export const ArrowDown = styled(ArrowUp)`
  transform: scaleY(-1);
`
